module.exports = __webpack_public_path__ + "static/media/award05.d13582bf.png";